import { render, staticRenderFns } from "./RoomLock.vue?vue&type=template&id=67b4b654&"
import script from "./RoomLock.vue?vue&type=script&lang=js&"
export * from "./RoomLock.vue?vue&type=script&lang=js&"
import style0 from "./RoomLock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports